import { useMemo } from 'react';

import { EditorView } from '@lyearn/lygo-core';

import { PopperProps } from '../../types';
import { getDomNode } from '../../utils';

export const useAnchorEl = (view: EditorView, open: boolean) => {
  return useMemo(() => {
    if (view && open) {
      return getDomNode(view, view.state.selection.$from.pos);
    }
    return null;
  }, [open]) as PopperProps['anchorEl'];
};

export const usePopperOptions = (view: EditorView, open: boolean) => {
  return useMemo(() => {
    const cursorPos = view.state.selection.$to.pos;
    const domNode = getDomNode(view, cursorPos);
    // @ts-ignore
    const getBoundingClientRect = domNode.getBoundingClientRect();
    const coordsPos = view.coordsAtPos(cursorPos) as any;
    const offset = [
      coordsPos.left - getBoundingClientRect.left,
      coordsPos.bottom - getBoundingClientRect.bottom,
    ];
    return {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset,
          },
        },
        {
          name: 'flip',
          enabled: false,
        },
      ],
    };
  }, [open]);
};
